import { isRequired, createValidator, combineValidators, isUrl } from 'app/validators/base'

export const validate = combineValidators(
  [isRequired(value => (typeof value === 'string' ? value.trim() : value)), isUrl(value => value)],
  true
)

export default createValidator(validate, 'videoThumbnail')
